<template>
  <div class="relative">
    <!-- Trigger Button -->
    <button class="dropdown-button flex items-center justify-center gap-1.5 pl-2 pr-2.5 py-1.5 rounded-md" :class="{ 'expanded': isOpen }"
    @click="isOpen = !isOpen">
      <SortIcon :width="20" :height="20" class="text-icon-normal" />
      <BaseText type="label" size="sm" class="text-text-muted">
        {{ currentLabel }}
      </BaseText>
    </button>
    <!-- Dropdown -->
    <transition>
      <div v-if="isOpen" class="dropdown-container flex flex-col gap-0.5 p-1" v-on-clickaway="() => isOpen = false">
        <div v-for="(category, index) in hydratedSortCategories" :key="`sort-category-${index}`"
        class="w-full flex flex-col gap-0.5">
          <!-- Category Header -->
          <div v-if="!noCategoryHeaders" class="w-full flex items-center gap-1 p-1.5">
            <component :is="category.icon" class="text-icon-muted" />
            <BaseText type="label" size="sm" class="text-text-muted">
              {{ category.label }}
            </BaseText>
          </div>
          <!-- Category Options -->
          <button v-for="option in category.options" :key="`sort-option-${option.value}`"
          class="w-full flex items-center p-1.5 rounded-md text-text-normal transition-colors duration-100"
          :class="option.isActive ? 'bg-neutral-25 text-text-muted' : 'hover:bg-neutral-25 hover:text-text-muted'"
          @click="selectSort(option.value)">
            <BaseText type="label" size="sm" class="flex-grow text-left px-1">
              {{ option.name }}
            </BaseText>
            <CheckmarkIcon v-if="option.isActive" class="text-text-subdued" />
          </button>
          <!-- Divider -->
          <div v-if="index < sortCategories.length - 1 && !noCategoryHeaders" class="w-full px-1.5 py-1">
            <div class="w-full h-0 border-t border-border-normal" />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway2'
import SortIcon from '../../globals/Icons/SortIcon.vue'
import CheckmarkIcon from '../../globals/Icons/CheckmarkIcon.vue'

export default {
  name: 'SortDropdown',
  mixins: [clickaway],
  components: {
    CheckmarkIcon,
    SortIcon
  },
  props: {
    selectedSort: {
      type: String,
      required: true
    },
    sortCategories: {
      type: Array,
      required: true
    },
    noCategoryHeaders: {
      type: Boolean,
      default: false
    },
    emitFullOption: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isOpen: false,
    }
  },
  computed: {
    currentLabel () {
      const match = this.sortCategories.flatMap((c) => c.options).find((o) => o.value === this.selectedSort)
      return match ? match.name : 'Sort'
    },
    hydratedSortCategories () {
      return this.sortCategories.map((category) => ({
        ...category,
        options: category.options.map((option) => ({
          ...option,
          isActive: option.value === this.selectedSort
        }))
      }))
    }
  },
  methods: {
    selectSort (sortKey) {
      if (this.emitFullOption) {
        const option = this.sortCategories.flatMap((c) => c.options).find((o) => o.value === sortKey)
        this.$emit('select-sort', option)
      } else {
        this.$emit('select-sort', sortKey)
      }
      this.isOpen = false
    }
  }
}
</script>

<style scoped>
.dropdown-container {
  position: absolute;
  right: 0px;
  top: calc(100% + 6px);
  width: 224px;
  border-radius: 10px;
  box-shadow: 0 12px 16px -8px rgba(24, 35, 68, 0.04), 0 2px 4px -1.5px rgba(24, 35, 68, 0.04), 0 1px 2px -0.75px rgba(24, 35, 68, 0.04), 0 0 0 1px rgba(0, 40, 136, 0.08);
  background-color: white;
  z-index: 1000;
}
.v-enter-active, .v-leave-active {
  transition: opacity 75ms ease-in-out;
}
.v-enter-from, .v-enter, .v-leave-to {
  opacity: 0;
}
.v-enter-to, .v-leave-from {
  opacity: 1;
}
</style>
